<script setup>
import { useI18n } from 'vue-i18n';
import LaisHeader from 'dashboard/components-next/LaisHeader.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

defineProps({
  currentTitle: { type: String, default: '' },
  saving: { type: Boolean, default: false },
});

const emit = defineEmits(['back', 'save']);
const { t } = useI18n();
</script>

<template>
  <LaisHeader
    :title="t('SALES_PROPERTY.TITLE')"
    :subtitle="t('SALES_PROPERTY.SUBTITLE')"
    :breadcrumb="[
      { label: t('SALES.TITLE') },
      { label: t('SALES.REGISTRATION.TITLE') },
      { label: currentTitle },
    ]"
    show-back
    :back-label="t('SALES_PROPERTY.ACTIONS.CANCEL')"
    @back="emit('back')"
  >
    <template #actions>
      <LaisPrimaryButton
        variant="ghost"
        icon="i-lucide-log-out"
        :is-loading="saving"
        @click="emit('save')"
      >
        {{ t('SALES_PROPERTY.ACTIONS.SAVE_AND_EXIT') }}
      </LaisPrimaryButton>
    </template>
  </LaisHeader>
</template>
